import {HistorieResponse, HistorieRequest} from "./../classes/historie";
import {
  Artikel,
  ArtikelRequest,
  ArtikelResponse,
  OrderResponse,
  OrderRequest,
  BestellPos,
  WarenkorbRequest,
  WarenkorbResponse,
} from "./../classes/artikel";
import {
  LoginRequest,
  Shop,
  Kondition,
  ChangePasswordRequest,
  ChangePasswordResponse,
  SendPasswordRequest,
  SendPasswordResponse,
} from "./../classes/login";
import {Injectable} from "@angular/core";
import {Storage} from "@ionic/storage";
import {LoadingController} from "@ionic/angular";
import {LoginResponse} from "../classes/login";
import {HttpClient} from "@angular/common/http";
import {getConfig} from "../classes/getConfig/getConfig";
import {Config} from "./../classes/config";
import {tap, map, catchError} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {Observable, of} from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DataService {
  public loggedIn = false;
  public username = "";
  public password = "";
  public save = false;
  public loginResponse: LoginResponse;
  public loading = false;
  public bestellPos = {};
  public allePosAnzeigen = true;
  public historieFilter: "lfHeute" | "lfGestern" | "lfAlle" | "beHeute" | "beGestern" | "beAlle" =
    "lfHeute";
  public constructed: Promise<void>;

  public installPrompt = null;

  public setAllePosAnzeigen(val) {
    this.allePosAnzeigen = val;
    this.storage.set("allePosAnzeigen", this.allePosAnzeigen);
  }

  public setHistorieFilter(val) {
    this.historieFilter = val;
    this.storage.set("historieFilter", this.historieFilter);
  }

  public config: Config;
  public baseUrl: string = environment.currentUrl;
  public showAGB: boolean;
  public shopAGBLink: string;

  constructor(
    private storage: Storage,
    private http: HttpClient,
    private loadingController: LoadingController,
  ) {
    this.constructed = this.storage
      .get("username")
      .then((val) => {
        this.username = val;
        return this.storage.get("password");
      })
      .then((val) => {
        this.password = val;
        return this.storage.get("historieFilter");
      })
      .then((val) => {
        if (val === null) {
          this.historieFilter = "lfHeute";
        } else {
          this.historieFilter = val;
        }
        return this.storage.get("allePosAnzeigen");
      })
      .then((val) => {
        if (val === null) {
          this.allePosAnzeigen = true;
        } else {
          this.allePosAnzeigen = val;
        }
        this.save = this.username !== "" || this.username !== "";
      });

    this.config = getConfig();
  }

  public setWarenkorb(shop: string, kondition: string, item: Artikel): Promise<Boolean> {
    const req = new WarenkorbRequest();
    req.username = this.username;
    req.password = this.password;
    req.shop = shop;
    req.kondition = kondition;
    req.bestelleinheit = item.bestelleinheit;
    req.multiplikator = item.multiplikator;
    req.pos = item.pos;
    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.baseUrl}app.ashx?action=setWarenkorb`, req)
        .toPromise()
        .then((val: any) => {
          const res: WarenkorbResponse = val;
          if (res.success) {
            resolve(true);
          } else {
            reject(res.errorText);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public login(reloadFromStorage: boolean): Promise<Boolean> {
    return new Promise((resolve, reject) => {
      this.loadingController.create({message: "Bitte warten"}).then((el) => {
        el.present();
        this.storage
          .get("username")
          .then((val) => {
            if (reloadFromStorage) {
              this.username = val;
            }
            return this.storage.get("password");
          })
          .then((val) => {
            if (reloadFromStorage) {
              this.password = val;
              this.save = this.username !== "" || this.username !== "";
            }
            const req = new LoginRequest();
            req.username = this.username;
            req.password = this.password;
            console.log(this.baseUrl);
            return this.http
              .post(`${this.baseUrl}app.ashx?action=login`, req)
              .toPromise()
              .catch((error) => {});
          })
          .then((value: any) => {
            // schreibt die daten aus POST login in die LoginResponse

            this.loginResponse = value;

            // sortiert die shops der der login response von z - a

            if (this.loginResponse.shops != null && this.loginResponse.shops.length === 0) {
              this.sortShopNames(this.loginResponse.shops);
            }

            if (this.loginResponse.success) {
              this.loggedIn = true;
              if (this.save) {
                this.storage.set("username", this.username);
                this.storage.set("password", this.password);
              }
              el.dismiss();
              resolve(true);
            } else {
              el.dismiss();
              reject(this.loginResponse.errorText);
            }
          })
          .catch((err) => {
            el.dismiss();
            reject(err);
          });
      });
    });
  }

  public changePasswort(oldPassword: string, newPassword: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.loadingController.create({message: "Bitte warten"}).then((el) => {
        el.present();
        const req = new ChangePasswordRequest();
        req.username = this.username;
        req.oldPassword = oldPassword;
        req.newPassword = newPassword;

        this.http
          .post(`${this.baseUrl}app.ashx?action=changePassword`, req)
          .toPromise()
          .then((val: any) => {
            const changePasswordRes: ChangePasswordResponse = val;
            if (changePasswordRes.success) {
              this.password = newPassword;
              if (this.save) {
                this.storage.set("password", this.password);
              }
              el.dismiss();
              resolve(true);
            } else {
              el.dismiss();
              reject(changePasswordRes.errorText);
            }
          })
          .catch((err) => {
            el.dismiss();
            reject(err);
          });
      });
    });
  }

  public sendPassword(email: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.loadingController.create({message: "Bitte warten"}).then((el) => {
        el.present();
        const req = new SendPasswordRequest();
        req.email = email;
        this.http
          .post(`${this.baseUrl}app.ashx?action=sendPassword`, req)
          .toPromise()
          .then((val: any) => {
            const sendPasswordRes: SendPasswordResponse = val;
            if (sendPasswordRes.success) {
              el.dismiss();
              resolve(true);
            } else {
              el.dismiss();
              reject(sendPasswordRes.errorText);
            }
          })
          .catch((err) => {
            el.dismiss();
            reject(err);
          });
      });
    });
  }

  public bestellen(
    shop: Shop,
    kondition: Kondition,
    pos: BestellPos[],
    lieferdatum: string,
    hinweis: string,
    bestellnummer: string,
  ): Promise<OrderResponse> {
    return new Promise((resolve, reject) => {
      this.loadingController.create({message: "Bitte warten"}).then((el) => {
        el.present();
        const req = new OrderRequest();
        req.username = this.username;
        req.password = this.password;
        req.shop = shop.nr;
        req.kondition = kondition.name;
        req.lieferdatum = lieferdatum;
        req.bemerkung = hinweis;
        req.bestellnummer = bestellnummer;
        req.pos = pos;

        this.http
          .post(`${this.baseUrl}app.ashx?action=order`, req)
          .toPromise()
          .then((val: any) => {
            const orderRes: OrderResponse = val;
            if (orderRes.success) {
              this.bestellPos[shop.nr][kondition.name] = {};
              el.dismiss();
              resolve(orderRes);
            } else {
              el.dismiss();
              reject(orderRes.errorText);
            }
          })
          .catch((err) => {
            el.dismiss();
            reject(err);
          });
      });
    });
  }

  public logout() {
    this.username = "";
    this.password = "";
    this.storage.set("username", "");
    this.storage.set("password", "");
    this.save = false;
    this.loggedIn = false;
  }

  public getData(shop: Shop, kondition: Kondition): Promise<ArtikelResponse> {
    return new Promise((resolve, reject) => {
      this.loadingController.create({message: "Bitte warten"}).then((el) => {
        el.present();
        const req = new ArtikelRequest();
        req.username = this.username;
        req.password = this.password;
        req.shop = shop.nr;
        req.kondition = kondition.name;

        this.http
          .post(`${this.baseUrl}app.ashx?action=getArtikel`, req)
          .toPromise()
          .then((val: any) => {
            const artikelRes: ArtikelResponse = val;
            // console.log(artikelRes);
            if (artikelRes.success) {
              el.dismiss();
              resolve(artikelRes);
            } else {
              el.dismiss();
              reject(artikelRes.errorText);
            }
          })
          .catch((err) => {
            el.dismiss();
            reject(err);
          });
      });
    });
  }

  public getHistorie(abLieferdatum: string, abBestelldatum: string): Promise<HistorieResponse> {
    return new Promise((resolve, reject) => {
      this.loadingController.create({message: "Bitte warten"}).then((el) => {
        el.present();
        const req = new HistorieRequest();
        req.username = this.username;
        req.password = this.password;
        req.abLfDatum = abLieferdatum;
        req.abBestDatum = abBestelldatum;

        this.http
          .post(`${this.baseUrl}app.ashx?action=historie`, req)
          .toPromise()
          .then((val: any) => {
            const artikelRes: HistorieResponse = val;
            if (artikelRes.success) {
              el.dismiss();
              resolve(artikelRes);
            } else {
              el.dismiss();
              reject(artikelRes.errorText);
            }
          })
          .catch((err) => {
            el.dismiss();
            reject(err);
          });
      });
    });
  }

  public sortShopNames = (loginResponseShops): void => {
    let listOfShops: Shop[] = loginResponseShops;

    // Könnte shopname immer als letzes haben
    // console.log(this.config.titel);

    // shopliste alphabetisch sortieren

    listOfShops.sort((a, b) => {
      if (a.name > b.name) {
        return -1;
      }
    });

    let plusPlants: Shop;

    listOfShops.forEach((element) => {
      // plusplants aus dem Array nehmen
      if (element.name === "PlusPlants" && this.config.titel.includes("PlusPlants")) {
        listOfShops = listOfShops.filter((item) => {
          plusPlants = element;
          return item !== element;
        });
      }
    });

    // console.log(plusPlants);

    // Plusplants als letzt Position hinzufügen

    if (plusPlants != null) {
      listOfShops.push(plusPlants);
    }

    this.loginResponse.shops = listOfShops;
  };

  checkIfAgbPdfExsists = (anliefererNr: number): Observable<any> => {
    return this.http.get(`https://pwa.plusplants.eu/Content/AGB/agb_${anliefererNr}.pdf`);
  };

  displayAgbBoolean = (anliefererNr: string) => {
    // Get Abfrage, um zu schauen ob die Url und PDF korrekt ist.

    if (this.config.titel.includes("PlusPlants")) {
      this.checkIfAgbPdfExsists(Number(anliefererNr)).subscribe((data) => {
        let contentTypeHeader = data.headers._headers.get("content-type");
        // console.log(contentTypeHeader[0]);

        // checken ob die angefrage Url auch eine PDF zurück gibt
        // console.log(anliefererNr);
        if (contentTypeHeader[0] == "application/pdf") {
          this.showAGB = true;
          this.shopAGBLink = `https://pwa.plusplants.eu/Content/AGB/agb_${anliefererNr}.pdf`;
        } else {
          this.showAGB = false;
        }
      });
    }
  };
}
